import React from 'react'
import ArticlesMobile from '../Articles/Mobile'
import { getProps } from './getProps'

export default (props) => <ArticlesMobile {...getProps(props)}/>
